import {Component, OnInit} from '@angular/core';
import {
  BaseComponent,
  WmsDialogBodyComponent,
  WmsDialogFooterComponent,
  WmsDialogHeaderComponent,
  WmsMessageComponent
} from "@wms/components";
import {DialogService, ProjectUpdatesService} from "@wms/services";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {VcsService} from "@wms/app/vcs/services/vcs.service";
import {getVcsAccountIconUrl, getVCSGroupData, toPascalCase} from "@wms/core";

@Component({
  selector: 'wms-vcs-user-credentials',
  templateUrl: './wms-vcs-user-credentials.component.html',
  styleUrls: ['./wms-vcs-user-credentials.component.less'],
  imports: [
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    WmsDialogHeaderComponent,
    WmsMessageComponent,
    CommonModule,
    FormsModule
  ],
  standalone: true
})
export class WmsVcsUserCredentialsComponent extends BaseComponent implements OnInit {
  message: any ='';
  vcsInfo: any;
  vcsAccountId: any;
  groupLabel: string;
  groupName: string;
  accessTokenLink: string;

  constructor(private dialogService: DialogService, private vcsService: VcsService, private projectUpdatesService: ProjectUpdatesService) {
    super();
    this.groupLabel = '';
  }

  ngOnInit() {
    this.vcsInfo      = this.vcsService.dialogParams.vcsInfo;
    this.vcsAccountId = this.vcsService.dialogParams.vcsAccountId;
    this.message = this.vcsInfo.developerKeysEnabled && this.projectUpdatesService.invalidRepoBranchInfo ? { 'type': 'error', 'caption': `${toPascalCase(this.vcsInfo.vcsAccountType)} ${this.locale.MESSAGE_VCS_USER_CREDENTIALS_NOT_FOUND_UPDATE}` } : null;
  }

  closeModal() {
    this.dialogService.close('vcsUserCredentials');
  }

  getVcsIcon() {
    return getVcsAccountIconUrl(this.vcsInfo.vcsAccountType, this.vcsService.baseURL);
  }

  getGroupName() {
    let groupData = getVCSGroupData(this.vcsInfo.vcsAccountType, this.vcsInfo.properties);
    this.groupName = groupData.groupName;
    this.groupLabel = groupData.groupLabel;
    this.accessTokenLink  = groupData.accessTokenLink;
    return groupData.groupName;
  }

  updateUserVCSCredentials() {
    let params = {
      vcsAccountId: this.vcsAccountId,
      data : {
        "userName"    :this.vcsInfo.username,
        "accessToken" :this.vcsInfo.accessToken || ''
      }
    }
    this.projectService.updateUserVCSCredentials(params).then((response: any) => {
      // show success msg and then close the existing dialog and trigger successCallback
      this.message = { 'type': 'success', 'caption': this.locale.MSG_USER_VCS_DETAILS_UPDATED };
      setTimeout( () => {
        this.dialogService.close('vcsUserCredentials');
      }, 1500);
    }, (error: any) => {
      let errorObject = error.error.errors.error[0];
      this.message = { 'type'   : 'error', 'caption': this.locale.MSG_ERR_USER_VCS_UPDATE_FAILED || errorObject.messageKey };
    });
  }
}
